// Dependencies
import axios from 'axios'
import { escape } from 'lodash'

// TODO - Para remover essa utilização do FireBase será necessário a integração com a nova API desenvolvida pelo Renan para o SiSU do Raiz
const baseUrl = (nome: string) =>
  `https://prosisu-faculdades.firebaseio.com/${nome}.json?print=pretty`

const baseUrlModal = (nome_uf: string, nome_curso: string) =>
  `https://prosisu-faculdades.firebaseio.com/${nome_uf}/${nome_curso}.json?print=pretty`

export async function getCursosByUF(nome: string) {
  try {
    const resp = await axios.get(baseUrl(nome))
    const aux = Object.keys(resp.data)
    let values: any[] = []
    values = aux.map((val: any) => {
      return { value: val, text: val }
    })
    return values
  } catch (error) {
    throw new Error('Falha ao carregar cursos')
  }
}

export async function getModalidadesByCursoAndUF(
  uf_name: string,
  course_name: string
) {
  try {
    const resp = await axios.get(baseUrlModal(uf_name, course_name))
    const aux = Object.keys(resp.data)
    return aux.map((val: any) => {
      return { value: val, text: val }
    })
  } catch (error) {
    throw new Error('Falha ao carregar modalidades')
  }
}

export async function getValuesByModalidade(data: any) {
  const uf = escape(data.uf)
  const course = escape(data.course)
  const modalidade = escape(data.modalidade)
  const url = `https://prosisu-faculdades.firebaseio.com/${uf}/${course}/${modalidade}.json?print=pretty`

  try {
    const resp = await axios.get(url)
    let results: any[] = []

    const linguagens = parseFloat(data.linguagens)
    const humanas = parseFloat(data.humanas)
    const redacao = parseFloat(data.redacao)
    const natureza = parseFloat(data.natureza)
    const matematica = parseFloat(data.matematica)

    resp.data.forEach((d: any) => {
      const notaHumanas = d.humanas
      const notaExatas = d.exatas
      const notaLinguagens = d.linguagens
      const notaNatureza = d.natureza
      const notaRedacao = d.redacao

      const ponderadaAluno =
        notaHumanas * humanas +
        notaExatas * matematica +
        notaLinguagens * linguagens +
        notaNatureza * natureza +
        notaRedacao * redacao

      const ponderadaPeso =
        notaHumanas + notaExatas + notaLinguagens + notaNatureza + notaRedacao

      const notaCorte = d.corte

      const ponderada = Math.floor(ponderadaAluno / ponderadaPeso)

      if (notaCorte <= ponderada) {
        results.push({
          ...d,
          status: 'aprovado',
          ponderada
        })
      } else {
        results.push({
          ...d,
          status: 'reprovado',
          ponderada
        })
      }
    })
    return results
  } catch (error) {
    throw new Error(`Erro ao obter os dados!!`)
  }
}
